var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#2B2B35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44666 3H17.2333L17.2418 3.00005C17.9829 3.00843 18.6875 3.28897 19.2613 3.77751C19.5388 4.01377 19.8649 4.34844 20.1121 4.88257C20.3555 5.40878 20.5 6.07966 20.5 6.96429V9.74999C20.5 10.1642 20.1642 10.5 19.75 10.5C19.3358 10.5 19 10.1634 19 9.74914V6.96429C19 6.24177 18.8821 5.79646 18.7507 5.51243C18.623 5.23632 18.4617 5.06671 18.2889 4.91963C17.9634 4.64246 17.5929 4.50504 17.2286 4.5H6.44666C5.97713 4.5 5.49377 4.7213 5.11441 5.17349C4.73177 5.62957 4.5 6.27229 4.5 6.96429V15.5357C4.5 16.2277 4.73177 16.8704 5.11441 17.3265C5.49377 17.7787 5.97713 18 6.44666 18H8.75C9.16421 18 9.5 18.3358 9.5 18.75C9.5 19.1642 9.16421 19.5 8.75 19.5H6.44666C5.4858 19.5 4.59734 19.044 3.96526 18.2906C3.33646 17.5411 3 16.5487 3 15.5357V6.96429C3 5.95131 3.33646 4.9589 3.96526 4.2094C4.59734 3.45599 5.4858 3 6.44666 3ZM20.2406 15.25L13.425 18.6578V11.8422L20.2406 15.25ZM13.7031 10.4719C12.955 10.0979 12.075 10.6418 12.075 11.4781V19.0219C12.075 19.8582 12.9551 20.4021 13.7031 20.0281L21.2468 16.2562C22.076 15.8416 22.076 14.6583 21.2468 14.2438L13.7031 10.4719Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.80337ccdf7f27f4a39bbd4da8e9a370b.svg";
export { ForwardRef as ReactComponent };